import React from "react";

const seal =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets/others/Benadir University Logo.png";

const PageHero = ({ kicker, title, subtitle }) => {
  return (
    <section className="pg-about-hero relative overflow-hidden">
      <div
        className="pg-about-orb pg-float"
        style={{
          width: "18rem",
          height: "18rem",
          top: "-4rem",
          right: "8%",
          background: "rgba(94, 179, 212, 0.18)",
        }}
        aria-hidden
      />
      <div
        className="pg-about-orb"
        style={{
          width: "14rem",
          height: "14rem",
          bottom: "-5rem",
          left: "4%",
          background: "rgba(8, 99, 170, 0.28)",
        }}
        aria-hidden
      />

      <div className="pg-page-hero relative mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <img
          src={seal}
          alt=""
          className="pg-animate-scale h-28 w-28 rounded-full bg-white object-contain p-1 shadow-[0_18px_40px_rgba(0,0,0,0.28)] sm:h-36 sm:w-36"
        />
        <div>
          {kicker && (
            <p className="pg-animate-in pg-pill">{kicker}</p>
          )}
          <h1 className="pg-animate-in-delay mt-4 max-w-3xl text-4xl font-bold text-white sm:text-5xl">
            {title}
          </h1>
          {subtitle && (
            <p className="pg-animate-in-delay-2 mt-4 max-w-2xl text-lg leading-relaxed text-sky-100/90">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
